<template>
   
  <div>
    <!-- <i class="iconfont">&#xe626;</i> -->
    <!-- <div class="row  tt_x_10 tt_10 b_x">
      <div class="col-3 middle col-00">
        <h4 class="z_15">服务社区</h4>
      </div>
      <div class="col-9 middle col-00">
        <input class="z_15" type="text" placeholder="填写服务社区" name="" id="" v-model="number" />
      </div>
    </div> -->
    <div class="jumbotron_c t_20" style="margin: 15px 15px 0">
      <div class="row">
        <div class="col-3" style="padding-right: 0px">
          <div style="padding: 10px 0px 10px 10px">
            <img style="width: 100%; height: 70px" :src="list.content_images" />
          </div>
        </div>
        <div class="col-9">
          <h5 class="bigtit">
            <p class="titleft">{{ list.content_name }}</p>
            <p class="titright">￥{{ list.integral }}积分</p>
          </h5>
          <!-- <div style="height: 5px;"></div> -->
          <footer class="blockquote-footer text-left">
            {{ address.join("｜") }}
          </footer>
          <!-- <h5 class="text-right" style="margin-bottom:0px; padding-top: 3px;"><span
              class="label label-primary-j">详细信息</span></h5> -->
        </div>
      </div>
    </div>
    <!-- <div class="bb">
      <div class="tt_10 tt_x_10">
        <div class="cente">
          <div class="lbl">
            兑换数量：
          </div>
          <div class="content">
            <input name="fname" class="left in" placeholder="请输入兑换数量" v-model="list.number">
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="cente">
          <div class="lbl">
            提货地址：
          </div>
          <div class="content">
            <select v-model="list.address">
              <option v-for="(option,aa) in address" :key="aa" v-bind:value="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="cente">
          <div class="lbl">
            姓名：
          </div>
          <div class="content">
            <input name="fname" class="left in" placeholder="请输入姓名" v-model="list.username">
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div class="cente">
          <div class="lbl">
            联系电话：
          </div>
          <div class="content">
            <input name="fname" class="left in" placeholder="请输入联系电话" v-model="list.telephone" @change="check">
            <p v-if="err" style="color: red;margin: 0;">手机号码不正确</p>
          </div>
        </div>
        <div style="height: 10px;"></div>
        <div><button @click="confirm" style="margin-right:20px">保存</button><button @click="cancel"
            style="background: rgb(152 169 185)">放弃修改</button>
        </div>
      </div>
    </div> -->
    <div class="bb">
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00">
          <h4 class="z_15">商品订单：</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right: 0">
          <input
            class="z_15"
            disabled="disabled"
            type="number"
            placeholder="商品订单"
            name=""
            id=""
            v-model="list.db_id"
            style="background: none; color: #2c3e50"
          />
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00">
          <h4 class="z_15">兑换数量：</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right: 0">
          <input
            class="z_15"
            disabled="disabled"
            type="number"
            placeholder="填写兑换数量(只能填数字)"
            name=""
            id=""
            v-model="list.number"
            style="background: none; color: #2c3e50"
          />
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00">
          <h4 class="z_15">提货地址：</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right: 0">
          <input
            class="z_15"
            disabled="disabled"
            type="text"
            placeholder="填写姓名"
            name=""
            id=""
            v-model="address"
            style="background: none; color: #2c3e50"
          />
        </div>
        <!-- <div class="col-9 middle col-00" style="padding-right:0">
          <div class="content">
            <select v-model="address[0]">
              <option v-for="(option,aa) in address" :key="aa" v-bind:value="option">
                {{ option }}
              </option>
            </select>
          </div>
        </div> -->
      </div>
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00">
          <h4 class="z_15 text-left">联系姓名：</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right: 0">
          <input
            class="z_15"
            disabled="disabled"
            type="text"
            placeholder="填写姓名"
            name=""
            id=""
            v-model="list.username"
            style="background: none; color: #2c3e50"
          />
        </div>
      </div>
      <div class="row tt_x_10 tt_10 b_x" style="padding-left: 10px">
        <div class="col-00">
          <h4 class="z_15">联系电话：</h4>
        </div>
        <div class="col-9 middle col-00" style="padding-right: 0">
          <input
            class="z_15"
            disabled="disabled"
            type="text"
            placeholder="填写联系电话"
            name=""
            id=""
            style="background: none; color: #2c3e50"
            v-model="list.telephone"
            @change="check"
          />
        </div>
        <p v-if="err" class="text-left" style="color: red; margin: 0">
          手机号码不正确
        </p>
      </div>
      <div style="height: 10px"></div>
      <div
        v-if="list.logistics == 7"
        style="margin: 15px auto; display: flex; justify-content: center"
      >
        <img src="https://img.hsnms.com/20211014/1634180541.jpg" />
      </div>
      <div
        v-else
        style="margin: 15px auto; display: flex; justify-content: center"
      >
        <div id="qrCode" ref="qrCodeDiv"></div>
      </div>
      <!-- <div><button @click="confirm" style="margin-right:20px">保存</button><button @click="cancel">放弃修改</button>
      </div> -->
    </div>
    <div id="d_p"></div>
    <pop :show5="showji" message="修改成功" @editshow="editshow" />
    <pop :show5="show5" message="请正确填写所有信息" @editshow="editshow1" />
  </div>
</template>
<script>
import user_model from "../tool/user_model";
import pop from "./popup.vue";
import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      showji: false,
      show5: false,
      edit5: false,
      ceshi: 123,
      selected: 1,
      name: "",
      tel: "",
      address: [],
      number: "",
      err: 0,
      list: [],
      openid: "",
    };
  },
  components: {
    pop,
  },
  props: {},
  created() {},
  mounted() {
    const info = user_model.getUserinfo();
    this.openid = info.openid;
    this.$api
      .getAPI(
        "mutual/order/" +
          this.$route.query.id +
          "?appid=202108&type_id=6001&state=1",
        { params: { openid: this.openid } }
      )
      .then((res) => {
        // this.$axios.get("app/mutual/order/" + this.$route.query.id + "?appid=202108&type_id=6001&state=1", { params: { openid: window.localStorage.getItem('openid') } }).then(res => {

        // console.log(res.data.data.models);
        this.list = res.data.data.models;
        console.log(this.list);
        this.$api
          .getAPI(
            "data/product/" +
              this.$route.query.cid +
              "?appid=202108&type_id=9001&state=1"
          )
          .then((res) => {
            console.log(res.data.data.models);
            this.address = res.data.data.models.key_value;
            this.address = this.address.split("｜");
            this.$nextTick(function () {
              // console.log(this.list.db_id);
              this.bindQRCode(this.list.db_id);
            });
          });
      });
  },
  methods: {
    bindQRCode: function (a) {
      new QRCode(this.$refs.qrCodeDiv, {
        text: "" + a + "",
        // text: '132',
        width: 200,
        height: 200,
        colorDark: "#333333", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
      });
    },
    editshow() {
      this.showji = false;
      this.$router.push("/user_order_list");
    },
    editshow1() {
      this.show5 = false;
    },
    // confirm () {
    //   if (this.list.number != '' && this.list.username != '' && this.list.telephone != '' && this.err == 0) {
    //     console.log(this.list.id, this.list.address);
    //     let data = new FormData()
    //     // data.append('content_id', this.$route.query.id)
    //     // data.append('content_name', this.$route.query.name)
    //     data.append('number', this.list.number)
    //     // data.append('integral', this.$route.query.price_a)
    //     // data.append('content_images', this.$route.query.imgages_max)
    //     // data.append('address', this.list.address)
    //     data.append('username', this.list.username)
    //     data.append('telephone', this.list.telephone)
    //     data.append('openid', window.localStorage.getItem('openid'))
    //     data.append('id', this.list.id)
    //     this.$api.postAPI(
    //       `mutual/order/` + this.$route.query.id + `?appid=202108&type_id=6001&state=1`,
    //       data).then(res => {
    //         console.log(res);
    //         //this.showji = true
    //         this.$router.push('/user_order_list')
    //         this.$Message.success("修改成功！")
    //       })
    //     // this.$axios({
    //     //   method: "POST",
    //     //   url: `app/mutual/order/` + this.$route.query.id + `?appid=202108&type_id=6001&state=1`,
    //     //   data: data,
    //     // }).then(res => {
    //     //   console.log(res);
    //     //   this.showji = true
    //     // });
    //   } else {
    //     // this.$Message.error("请先点亮小星星！")
    //     console.log(this.list.address);
    //     this.$Message.error('请正确填写所有信息')
    //     // this.show5 = true
    //   }

    // },
    // cancel () {
    //   // this.$router.push('/mall_list')
    //   this.$router.back(-1)
    // },
    check() {
      if (!/^1[34578]\d{9}$/.test(this.list.telephone)) {
        this.err = 1;
        // console.log(1);
        return false;
      } else {
        this.err = 0;
      }
      // console.log(this.err);
    },
  },
};
</script>
<style>
.edit5 {
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 300px;
  height: 125px;
  background: #fff;
  z-index: 990;
  overflow: hidden;
  border-radius: 20px;
  padding: 10px 20px;
  box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 15%);
}
.edit5 button {
  height: 35px;
  width: 150px;
  border-radius: 3px;
  border: none;
  background: #01b2c2;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 6px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}
input {
  border: none;
  border-radius: 5px;
  padding-left: 8px;
}
.cente {
  /* text-align: justify; */
  display: flex;
  width: 100%;
  margin: 10px 0;
}
.cente .lbl {
  flex: 1;
  text-align: left;
  position: relative;
  top: 3px;
  font-size: 15px;
}
.content {
  text-align: left;
  width: 100%;
}
.content input {
  border: 1px solid #bbb;
  padding: 3px 5px;
  border-radius: 5px;
  width: 100%;
}
.content select {
  border: 1px solid #bbb;
  padding: 3px 5px;
  border-radius: 5px;
  width: 100%;
}
.bb {
  margin-left: 20px;
  margin-right: 20px;
  padding: 10px;
}
.bb button {
  height: 35px;
  width: 100px;
  border-radius: 3px;
  border: none;
  background: #01b2c2;
  color: #fff;
  margin-left: 10px;
  cursor: pointer;
  margin: 6px auto 10px;
  /* margin-top: 25px; */
  text-align: center !important;
}
.jumbotron {
  padding: 2rem 2rem;
  margin-bottom: 2rem;
}

.label_50 {
  border-radius: 50px/50px;
}

.page-header {
  margin: 25px 0 0px;
}

.h5_t_5 {
  margin-top: 15px;
}

.b_t_5 {
  padding-top: 6px;
}

.border_ {
  background: #002752;
}

.carousel-inner {
  border-bottom: 1px solid #000;
}

.carousel-indicators {
  bottom: -40px;
}

.carousel-indicators li {
  background-color: #000000;
}

.carousel-item-img {
  border-top-left-radius: 0.8em;
  border-top-right-radius: 0.8em;
  background-color: transparent;
  box-shadow: 0px 0px 8px 3px #fff;
}

.border {
  display: inline-block;
  width: 70px;
  height: 70px;
  margin: 6px;
}

.jumbotron_a {
  color: #fff;
  background: #01b2c2;
}

.jumbotron_b {
  color: #fff;
  background: #3480fa;
}

.jumbotron_c {
  background: #f3f4f8;
}

.carousel-indicators li {
  width: 8px;
  height: 8px;
  background-color: #00cdc6;
}

.carousel-indicators .active {
  background-color: #00a4b7;
  width: 30px;
  height: 8px;
}

.label-primary {
  color: #3480fa;
  background-color: #ffd986;
}

.label-primary-j {
  color: #fff;
  background-color: #00a4b7;
  border-radius: 15px 0px 0px 0px;
}
.bigtit {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0;
  height: 25px;
  line-height: 25px;
  margin-top: 15px;
}
.titleft {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 160px;
  text-align: left;
}
.titright {
  font-size: 80%;
  color: #6c757d;
  display: block;
  margin-right: 10px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/views/details.vue